import { FormFieldModel, FormFieldValidator } from '@alfresco/adf-core';

export class EbenEmailSelectorValidator implements FormFieldValidator {

  public static invalidEmails: string = 'invalidEmails';
  public static invalidEmailFormat: string = 'invalidEmailFormat';

  isSupported(field: FormFieldModel): boolean {
    return field.type === 'email-selector';
  }

  validate(field: FormFieldModel): boolean {
    if (this.isSupported(field)) {

      const isInvalidEmailFormat = !!field.params[EbenEmailSelectorValidator.invalidEmailFormat];
      const hasInvalidEmails: boolean = field.params[EbenEmailSelectorValidator.invalidEmails] && Array.isArray(field.params[EbenEmailSelectorValidator.invalidEmails]) && (field.params[EbenEmailSelectorValidator.invalidEmails] as string[]).length > 0;

      if(isInvalidEmailFormat || hasInvalidEmails) {
        field.validationSummary.message = 'EMAIL-SELECTOR.ERROR.INVALID_EMAIL_FORMAT';
        field.validationSummary.attributes = new Map<string, string>();
        field.validationSummary.attributes.set('fieldname', field.name);
        return false;
      }
    }
    return true;
  }
}
